module.exports = __webpack_public_path__ + "img/FR11006.8633d198.png";